<app-section-layout [dataForChart]="graphData" [itemTemplate]="potashPrices"></app-section-layout>

<ng-template #potashPrices let-data="data" let-navInfo="navInfo">
    <app-prices-table [data]="data.graph"></app-prices-table>
</ng-template>